<template>
  <span class="status-badge" :class="badgeClass">
    {{ status }}
  </span>
</template>

<script>
export default {
  name: 'StatusBadge',
  props: {
    status: {
      type: String,
      required: true
    }
  },
  computed: {
    badgeClass() {
      switch (this.status) {
        // Ticket statuses
        case 'Fully Paid':
          return 'status-good';
        case 'In Progress':
          return 'status-neutral';
        case 'Late Payment':
          return 'status-critical';
        case 'Cancelled':
          return 'status-cancelled';
        // Receivable statuses
        case 'Paid':
          return 'status-good';
        case 'Upcoming':
          return 'status-neutral';
        case 'Due Today':
          return 'status-warning';
        case 'Overdue':
          return 'status-critical';
        // TRT program phases
        case 'Getting Started':
          return 'status-neutral';
        case 'Awaiting Items':
          return 'status-warning';
        case 'Ready to Prescribe':
          return 'status-good';
        case 'Taking TRT':
          return 'status-good';
        case 'Renewal Due':
          return 'status-warning';
        case 'No Longer Taking TRT':
          return 'status-cancelled';
        default:
          return '';
      }
    }
  }
};
</script>

<style scoped>
.status-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: var(--border-radius);
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
}

/* Semantic color system */
.status-good {
  background-color: #d6eba3;
  color: #155724;
}

.status-neutral {
  background-color: #eceef0;
  color: #47494d;
}

.status-warning {
  background-color: #fff3cd;
  color: #856404;
}

.status-critical {
  background-color: #f8d7da;
  color: #721c24;
}

.status-cancelled {
  background-color: #e2e3e5;
  color: #383d41;
}
</style>
